import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify';
import firebase from 'firebase/app'

// Configure
import configMeta from './config/meta'
import configUrl from './config/url'
import configError from './config/error'
import configRule from './config/rule'
import configFirebase from './config/firebase'

// Utilities
import VueAxios from 'vue-axios'
import axios from 'axios'
import _ from 'lodash'
import { v4 as uuid } from 'uuid'
import moment from 'moment'

// Icons Font
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Init FontAwesome
library.add(fal)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Init Firebase
firebase.initializeApp(configFirebase)

// Init axios
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

// Global Meta Data
Vue.prototype.$mango = configMeta
Vue.prototype.$url = configUrl
Vue.prototype.$rule = configRule
Vue.prototype.$error = configError
Vue.prototype.$firebase = firebase
Vue.prototype.$_ = _
Vue.prototype.$uuid = uuid
Vue.prototype.$moment = moment
Vue.prototype.$author = {
  auth: function (user) {
    return new Promise((resolve, reject) => {
      firebase.database().ref('authors').orderByChild('status').startAt('active').endAt('active').limitToFirst(100).once('value').then((snapshot) => {
        const data = snapshot.val()
        const keys = Object.keys(data)

        let result = { author: {}, authors: {} }
        for (let i = 0; i < keys.length; i++) {
          const author = data[keys[i]]
          const { userid, name, roles, authority, nickname } = author
          const item = Object.assign({}, author, {
            name: name ? name.split(',') : ['', ''],
            roles: roles ? roles.split(',') : [],
            authority: authority ? authority.split(',') : [],
            nickname: nickname || ''
          })
          result.authors[userid] = item
          if (keys[i] === user.uid) {
            result.author = item
          }
        }
        resolve(result)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  authors: function () {
    return new Promise((resolve, reject) => {
      firebase.database().ref('authors').orderByChild('status').startAt('active').endAt('active').limitToFirst(100).once('value').then((snapshot) => {
        const data = snapshot.val()
        const keys = Object.keys(data)
        let authors = {}
        for (let i = 0; i < keys.length; i++) {
          const author = authors[keys[i]]
          const { userid, name, roles, authority } = author
          authors[userid] = Object.assign({}, author, {
            name: name ? name.split(',') : ['', ''],
            roles: roles ? roles.split(',') : [],
            authority: authority ? authority.split(',') : []
          })
        }
        resolve(authors)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  consultants: function () {
    return new Promise((resolve, reject) => {
      firebase.database().ref('authors').orderByChild('status').startAt('active').endAt('active').limitToFirst(100).once('value').then((snapshot) => {
        let authors = snapshot.val()
        resolve(Object.keys(authors).filter(key => {
          return (
            authors[key].userid &&
            authors[key].status &&
            authors[key].roles &&
            authors[key].status === 'active' &&
            authors[key].roles.split(',').includes('consultant')
          )
        }).map(key => {
          return {
            userid: authors[key].userid,
            name: authors[key].name ? authors[key].name.split(',') : ['', ''],
            belong: authors[key].belong ? authors[key].belong : ''
          }
        }))
      }).catch((err) => {
        reject(err)
      })
    })
  },
  arrangers: function () {
    return new Promise((resolve, reject) => {
      firebase.database().ref('authors').orderByChild('status').startAt('active').endAt('active').limitToFirst(100).once('value').then((snapshot) => {
        let authors = snapshot.val()
        resolve(Object.keys(authors).filter(key => {
          return (
            authors[key].userid &&
            authors[key].status &&
            authors[key].roles &&
            authors[key].status === 'active' &&
            authors[key].roles.split(',').includes('arranger')
          )
        }).map(key => {
          return {
            userid: authors[key].userid,
            name: authors[key].name ? authors[key].name.split(',') : ['', ''],
            belong: authors[key].belong ? authors[key].belong : ''
          }
        }))
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
